module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "sticker"
    }
  }, [_c('div', {
    attrs: {
      "id": "stickerCon"
    }
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29410dfc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Container.vue
// module id = 1403
// module chunks = 28